// TODO:
// 1. icon selector
// 2. link click action

import React from 'react';

import * as S from './MyTripActions.styles';

import IconSelector from '@ibibo/icon-selector';

const ActionsCategoryLinks = ({name, links}) => {
  return (
    <S.TripActionWrap>
      <S.TripActionHeadText>{name}</S.TripActionHeadText>
      {links.map(link => <S.TripActionInnerWrap key={link.title}>
        <S.TripActionIconWrap>
          <IconSelector iconKey={link.icon} />
        </S.TripActionIconWrap>
        <S.TripActionText href={link.link}>{link.title}</S.TripActionText>
      </S.TripActionInnerWrap>)}
    </S.TripActionWrap>
  );
}

const MyTripActions = ({actionLinks}) => {

  const actionCategories = Object.keys(actionLinks);
  if (!actionCategories.length) {
    return null;
  }

  return(
    <S.MyTripsActionMainWrap>
      <S.MyTripsActionInnerWrap>
        {(actionCategories.map(category => <ActionsCategoryLinks name={category} links={actionLinks[category]} key={category} />)) || null}
      </S.MyTripsActionInnerWrap>
    </S.MyTripsActionMainWrap>
  );
}

export default MyTripActions;